<template>
  <div class="modal fade" id="addBankAccount" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="addBankAccountLabel">Add bank account</h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x"
                          data-dismiss="modal"
                          id="closeAddBankAccount"
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                  <div>
                    <!-- <router-link :to="{ path: path}" target="_blank">
                                <span class="fa-stack fa-2x fsm float-right">
                                    <i class="far fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-external-link-alt fa-stack-1x"></i>
                                </span>
                    </router-link>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <form @submit.prevent="onSubmit" name="bankAccount">
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-sm-10 col-lg-9">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="row mt-3">
                                <div class="col-sm-4">
                                  <label>Account name:</label>
                                </div>
                                <div class="col-sm-8 mt--20">
                                  <input
                                    type="text"
                                    class="form-control underline"
                                    name="Account Name"
                                    required
                                    v-model="name"
                                    pattern="^[A-Za-z -]+$"
                                  />
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-sm-4">
                                  <label>Account Number:</label>
                                </div>
                                <div class="col-sm-8 mt--20">
                                  <input
                                    placeholder="Numbers Only e.g. 12345678"
                                    class="form-control underline"
                                    name="Account Number"
                                    required
                                    type="text"
                                    pattern="\d*"
                                    minlength="7"
                                    maxlength="8"
                                    v-model="accNumber"
                                    @keypress="autotab($event, index)"
                                  />
                                  <!-- <input name="somename" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" type = "number" maxlength = "6"/> -->
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-sm-4">
                                  <label>Sort Code:</label>
                                </div>
                                <div class="col-sm-8 mt--20">
                                  <input
                                    placeholder="Numbers Only e.g. 123456"
                                    class="form-control underline"
                                    name="Account Sort Code"
                                    required
                                    type="text"
                                    pattern="\d*"
                                    minlength="6"
                                    maxlength="6"
                                    v-model="sortcode"
                                    @keypress="autotab($event, index)"
                                  />
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-sm-4">
                                  <label>Organisation:</label>
                                </div>
                                <div class="col-sm-8">
                                  <b-form-select
                                    v-model="ddOrganisationId"
                                    class="form-control"
                                    name="selection"
                                    required
                                  >
                                    <option
                                      v-for="(organisation, index) in organisations"
                                      :key="index"
                                      :value="organisation.id"
                                    >{{organisation.name}}</option>
                                  </b-form-select>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-12 mt-4">
                              <!-- <div class="chiller_cb"> -->
                              <!-- <input id="makeThisTheDefaultAccountCheckbox" type="checkbox" checked v-model="checkbox">
                                    <label for="makeThisTheDefaultAccountCheckbox">Make this the default account for
                                    payments:
                              </label>-->
                              <span></span>
                              <!-- </div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2 col-lg-3 mobile-space-t">
                      <!-- THIS IS WHERE THE BANK LOG NEEDS TO GO <p>Bank logo goes here once a sortcode is entered</p> -->
                      <!-- <img src="@/assets/img/natwest_logo_lg.png" class="img-fluid mx-auto d-block" alt="Natwest Bank Logo"> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-hc float-right"
              :disabled="submitStatus === 'PENDING'"
            >
              Submit bank
              details
            </button>
            <!-- <p class="typo__p" v-if="submitStatus === 'OK'" >Thanks for your submission! </p>
              <p class="typo__p" v-if="submitStatus === 'ERROR'">Please fill the form correctly.</p>
            <p class="typo__p" v-if="submitStatus === 'PENDING'">Sending...</p>-->
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { uuid } from "vue-uuid";

export default {
  data() {
    return {
      submitStatus: null,
      notificationClasses: null,
      name: null,
      accNumber: null,
      sortcode: null,
    };
  },
  validations: {
    ddOrganisationId: {
      required,
    },
    name: {
      required,
    },
    accNumber: {
      required,
      minLength,
      maxLength,
    },
    sortcode: {
      required,
      minLength,
      maxLength,
    },
  },
  computed: {
    path() {
      return window.location.pathname;
    },
    organisations() {
      return this.$config.honeycomb.ddbot.organisations;
    },
    ddOrganisationId: {
      get() {
        return this.$store.state.finances.ddOrganisationId;
      },
      set(org) {
        this.$store.commit("updateDdOrganisationId", org);
      },
    },
  },
  methods: {
    autotab: function($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode > 47 && keyCode < 58) {
        return $event.target.nextElementSibling.focus();
      }
      return $event.preventDefault();
    },
      onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";
        this.$http
          .post(
            "https://" +
              this.$config.honeycomb.ddbot.domain +
              "/api/v1/lodgements/validate",
            {
              AccountName: this.name,
              AccountNumber: this.accNumber,
              SortCode: this.sortcode,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            if (
              response.data.hasOwnProperty("IsValid") &&
              response.data.IsValid == false
            ) {
              this.$snotify.warning(`Invalid bank details.`);
            } else {
              this.$snotify.success(`Bank details validated.`);
              setTimeout(() => {
                this.$http
                  .post(
                    "Https://" +
                      this.$config.honeycomb.ddbot.domain +
                      "/api/v1/lodgements",
                    {
                      AccountId: this.$store.state.customers.customer.AccountId,
                      AccountName: this.name,
                      AccountNumber: this.accNumber,
                      SortCode: this.sortcode,
                      DdOrganisationId: this.ddOrganisationId,
                      Action: "StoreAndLodge",
                      LodgementId: uuid.v1(),
                      SharedId: uuid.v1(),
                    },
                    {
                      withCredentials: true,
                    }
                  )
                  .then(() => {
                    document.getElementById("closeAddBankAccount").click();
                    this.submitStatus = "OK";
                    // if (_.findWhere(this.$store.state.finances.bankDetails,{EffectiveTo: null} != null)) {
                    var ordered = this.$_.sortBy(
                      this.$store.state.finances.bankDetails,
                      "EffectiveFrom"
                    ).reverse();
                    (ordered[0] &&
                        this.$http
                        .put(
                          "https://" +
                            this.$config.honeycomb.ddbot.domain +
                            "/api/v1/lodgements/" +
                            ordered[0].Id,
                            {
                            AccountId: this.$store.state.customers.customer.AccountId,    
                            EffectiveTo: new Date(), //moment.utc(moment().format('YYYY-MM-DD')).format(),
                          },
                          {
                            withCredentials: true,
                          }
                        )
                    .then(() => {
                          this.name = null;
                          this.accNumber = null;
                          this.sortcode = null;
                          this.$snotify.success(`Success! Account added.`);
                          this.$store.dispatch("getBankDetails");
                        })) ||
                      (() => {
                        this.$store.dispatch("getBankDetails");
                      })();
                    // }
                  })
                  .catch((error) => {
                    // Error
                    if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      this.submitStatus = "Error";
                      if (error.response.data.MoreInformation.length > 0) {
                        error.response.data.MoreInformation.forEach((e) => {
                          this.$snotify.error(`${e.Error}`, {
                            timeout: 0,
                            closeOnClick: true,
                          });
                        });
                      } else {
                        this.$snotify.error(
                          `${error.response.data.UserDescription}`,
                          {
                            timeout: 0,
                            closeOnClick: true,
                          }
                        );
                      }
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      this.$snotify.error(`No response received.`, {
                        timeout: 0,
                        closeOnClick: true,
                      });
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      this.submitStatus = "Error";
                      this.$snotify.error(`${error.message}`, {
                        timeout: 0,
                        closeOnClick: true,
                      });
                    }
                  });
              }, 1200);
            }
          })
          .catch((error) => {
            // Error
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              // this.submitStatus = 'Error'
              if (error.response.data.MoreInformation.length > 0) {
                error.response.data.MoreInformation.forEach((e) => {
                  this.$snotify.error(`${e.Error}`, {
                    timeout: 0,
                    closeOnClick: true,
                  });
                });
              } else {
                this.$snotify.error(`${error.response.data.UserDescription}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              // this.submitStatus = 'Error'
              this.$snotify.error(`No response received.`, {
                timeout: 0,
                closeOnClick: true,
              });
            } else {
              // Something happened in setting up the request that triggered an Error
              // this.submitStatus = 'Error'
              this.$snotify.error(`${error.message}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          });
      }
    },
  },
};
</script>
